export const chartDays = [
    {
        label: "24 Hr",
        value: 1,
    },
    {
        label: "30 D",
        value: 30,
    },
    {
        label: "3 M",
        value: 90,
    },
    {
        label: "1 Yr",
        value: 365,
    },
];
